const NEW = 'NEW';
const MODIFY = 'MODIFY';
const COPY = 'COPY';

export default {
  NEW,
  MODIFY,
  COPY
};
